export const PLAYER_HUB_ROUTE = '/player';
export const PREVIEW_ROUTE = '/preview';
